export enum EpisodeSelectMode {
    RoutineTreatment,
    GenericPrescriptionEpisode,
    ExistingEpisode,
    NewEpisode,
    EditEpisode,
    None,
    SelfDirectedGymRecovery
}
